import { mapGetters } from 'vuex'

export default {
  cloning: true,
  data () {
    return {
      isLoading: false,
      old: null,
      hasCloned: false
    }
  },
  computed: {
    ...mapGetters({
      activeModal: 'modal/activeModal',
      confirmModal: 'modal/confirmModal',
      modalParams: 'modal/modalParams'
    })
  },
  methods: {
    handleCloseModal (e) {
      if (e.keyCode === 27) {
        this.closeModal()
      }
    },
    closeModal () {
      // this.$validator.reset()

      // setTimeout(() => {
      //   this.$eventHub.$emit('closeModal')
      // }, 500)

      // if (this.confirmModal.opened) {
      //   this.$store.dispatch('setConfirmModalStatus', false)
      //   return
      // }
      this.$store.dispatch('modal/close')
    }
    // validate (url, data, override = false) {
    //   this.isLoading = true

    //   var method = this.modalParams ? 'put' : 'post'

    //   // Uploaded formdata should be converted to post
    //   if (data instanceof FormData) {
    //     method = 'post'
    //   }

    //   if (override) {
    //     url = window.route(url)
    //   } else {
    //     url = this.modalParams ? window.route(url + '.update', this.modalParams.id) : window.route(url + '.store')
    //   }

    //   return this.$validator.validateAll().then(response => {
    //     return new Promise((resolve, reject) => {
    //       if (response) {
    //         return axios({ method: method, url, data })
    //           .then(response => {
    //             this.isLoading = false
    //             return resolve(response)
    //           })
    //           .catch(error => {
    //             this.isLoading = false
    //             return reject(new Error(error))
    //           })
    //       }

    //       this.isLoading = false
    //       return reject(new Error('Validation failed.'))
    //     })
    //   })
    // }
  },
  created () {
    // var { old, ...data } = this._data

    // this.old = clone(data)

    document.addEventListener('keydown', this.handleCloseModal)

    // if (this.modalParams && this.$options.cloning) {
    //   this.model = cloneDeep(this.modalParams)
    //   this.hasCloned = true
    // }

    // if (this.applicant) {
    //   this.model.applicant_id = this.applicant.id
    // }
  },
  destroyed () {
    document.removeEventListener('keydown', this.handleCloseModal)

    // forOwn(this.old, (value, key) => {
    //   this[key] = clone(value)
    // })
  }
}
